import { HStack } from "@chakra-ui/react";

export function Footer() {
  return (
    <HStack w={"100%"} pt={10} px={10} justifyContent={"space-around"}>
      <HStack spacing={8} fontSize={18}>
        <a
          href="/datenschutz"
          title={
            "Link zur Datenschutzerklärung der Webdesign Agenutr WebWerk am Meer"
          }
        >
          Datenschutz
        </a>
        <a
          href="/impressum"
          title={"Link zum Impressum der Webdesign Agenutr WebWerk am Meer"}
        >
          Impressum
        </a>
      </HStack>
    </HStack>
  );
}
